const appBarStyle = { borderBottom: '1px solid rgba(0, 0, 0, 0.12)' };
const toolbarStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
};

export { appBarStyle, toolbarStyle };
